import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const ExamesContext = createContext();

export function ExamesProvider({ children }) {
  const [examesSelecionados, setExamesSelecionados] = useState(new Map());
  
  const toggleExame = useCallback((exameId, exame) => {
    setExamesSelecionados(prev => {
      const novo = new Map(prev);
      if (novo.has(exameId)) {
        novo.delete(exameId);
      } else {
        if (exame) {
          novo.set(exameId, exame);
        }
      }
      return novo;
    });
  }, []);
  
  const limparSelecoes = useCallback(() => {
    setExamesSelecionados(new Map());
  }, []);
  
  const atualizarExame = useCallback((exameId, exame) => {
    setExamesSelecionados(prev => {
      const novo = new Map(prev);
      if (novo.has(exameId)) {
        novo.set(exameId, exame);
      }
      return novo;
    });
  }, []);
  
  const value = useMemo(() => ({
    examesSelecionados,
    toggleExame,
    limparSelecoes,
    atualizarExame,
  }), [examesSelecionados, toggleExame, limparSelecoes, atualizarExame]);
  
  return (
    <ExamesContext.Provider value={value}>
      {children}
    </ExamesContext.Provider>
  );
}

export function useExames() {
  const context = useContext(ExamesContext);
  if (!context) {
    throw new Error('useExames deve ser usado dentro de ExamesProvider');
  }
  return context;
}
